// The surface → nav ICON mapping (design brief §3 icons; geometry from the prototype NAV). Kept separate
// from the surface registry so the role/routing model (surfaces.ts) stays presentation-free — the icon is a
// nav affordance, not part of the surface's identity. Every SurfaceId has exactly one icon.

import type { IconName } from './Icon.tsx';
import type { SurfaceId } from './surfaces.ts';

/** One icon per surface, matching the prototype's nav glyphs. */
export const SURFACE_ICONS: Readonly<Record<SurfaceId, IconName>> = {
  work: 'compass',
  home: 'today',
  tasks: 'tasks',
  metrics: 'kpis',
  scheduler: 'clock',
  approvals: 'approvals',
  memory: 'memory',
  files: 'files',
  team: 'team',
  settings: 'settings',
  journeys: 'history',
  monitoring: 'pulse',
  connectors: 'plug',
  capmap: 'grid',
  governance: 'approvals',
};
